<div id="primary-btn-flourish">
  <ra-ui-main-button
    label="{{ label }}"
    [color]="buttonColor"
    [disabled]="isDisabled"
    (onClick)="onClickButton($event)"
  >
  </ra-ui-main-button>
</div>
